/* AI prompt buttons (SSM-562).
   Claude shows a red caution banner whenever prompt text arrives in the query
   string, so buttons flagged for it carry the prompt in data-ai-copy instead:
   we put it on the clipboard and let the reader paste.

   The destination URL keeps a bare ?q= with nothing after it, and that empty
   parameter is load-bearing, not leftover. Claude prefills the composer from
   q, so an empty q writes an empty composer and clears any unsent draft saved
   from a previously visited article. Without it the reader pastes into a box
   that may still hold the last article's prompt. Empty q does not trip the
   caution banner; only actual prompt text does.

   Two clicks, because the tab used to steal focus before the paste instruction
   could be read. First click copies and arms, second click opens. The second
   click deliberately does not preventDefault, so the anchor's target="_blank"
   does the opening: no window.open, nothing for a popup blocker to catch. */
(function () {
  var ARM_LIFETIME = 30000;
  var armed = null;
  var armTimer;

  function statusFor(link) {
    var group = link.closest('.bpbc__ask');
    return group ? group.querySelector('.bpbc__ask-status') : null;
  }

  /* Started inside the click so the write stays in the user gesture and lands
     before focus moves to the new tab. Runs on both clicks, so the clipboard
     cannot be stale by the time the second one opens the destination. */
  function copy(link) {
    var text = link.getAttribute('data-ai-copy');
    if (text) navigator.clipboard.writeText(text);
  }

  function disarm() {
    if (!armed) return;
    var status = statusFor(armed);
    if (status) status.textContent = '';
    armed.classList.remove('bpbc__ask-item--armed');
    clearTimeout(armTimer);
    armed = null;
  }

  function arm(link) {
    var status = statusFor(link);
    var name = link.getAttribute('data-ai-copy-name') || 'your assistant';

    armed = link;
    link.classList.add('bpbc__ask-item--armed');
    if (status) {
      status.textContent = 'Prompt copied. Click again to open ' + name + '.';
    }
    armTimer = setTimeout(disarm, ARM_LIFETIME);
  }

  function init() {
    var links = document.querySelectorAll('a[data-ai-copy]');
    if (!links.length || !navigator.clipboard) return;

    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        /* Let power users keep cmd/ctrl/shift/middle click. They skip the
           two-step and lose the instruction, but the prompt is still copied. */
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1) {
          copy(link);
          return;
        }

        if (armed === link) {
          copy(link);
          disarm();
          return;
        }

        event.preventDefault();
        disarm();
        copy(link);
        arm(link);
      });
    });

    /* Arming one button should not leave its message standing next to a
       different action, so any other button in the group clears it. */
    document.querySelectorAll('.bpbc__ask-item:not([data-ai-copy])').forEach(function (other) {
      other.addEventListener('click', disarm);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
